<template>
  <div>
    <icon-view
      class="mr-2 mt-5 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-cloud-upload-alt color-orange mb-1"
      title="Sección de Archivos"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
      :gradient="true"
    />
    <div class="row" v-if="!hasThumbnailImageFile">
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded pt-4 px-5"
          :has-border="false"
          :has-toggle="false"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              id="input-thumbnail"
              ref="fileUpload"
              display-style="normal"
              :on-download="downloadFile"
              :accept="'.png,.jpg,.jpeg'"
              label-position="left"
              addText="Presione aquí para anejar imagen miniatura"
              :error="errors[0]"
              custom-error-msg="La imagen miniatura es requerida."
              class="w-50 mx-auto"
              :value="model.thumbnail"
              @input="
                file => {
                  model.thumbnail = file;
                }
              "
            />
            <p class="text-center">
              La imagen debe contener un tamaño de 274x137 píxeles
            </p>
          </validation-provider>
        </custom-callout>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Documento:</div>
              <div class="color-black font-16">
                {{ thumbnailImageFile.documentTypeName | empty }}
              </div>
            </div>
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Archivo:</div>
              <div class="color-black font-16">
                {{ thumbnailImageFile.fileName | empty }}
              </div>
            </div>
            <div
              class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
            >
              <action-button
                id="download-thumbnail-btn"
                class="btn-action-size ml-2"
                i="fas fa-file-download"
                variant="success"
                @click="onDownloadFile(thumbnailImageFile.documentId)"
              />
              <action-button
                id="replace-thumbnail-btn"
                class="px-1 btn-action-size ml-2"
                i="fas fa-undo-alt"
                variant="outline-success"
                @click="onReplaceThumbnailFileHandler()"
              />
              <input
                id="thumbnailFile"
                ref="thumbnailRef"
                type="file"
                style="display: none"
                accept="image/*"
                @change="onUploadThumbnailFileHandler()"
              />
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
    <div class="row" v-if="!hasMainImageFile">
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded pt-4 px-5"
          :has-border="false"
          :has-toggle="false"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              id="input-mainImage"
              ref="fileUpload"
              display-style="normal"
              addText="Presione aquí para anejar imagen principal"
              :on-download="downloadFile"
              :accept="'.png,.jpg,.jpeg'"
              label-position="left"
              :error="errors[0]"
              custom-error-msg="La imagen principal es requerida."
              class="w-50 mx-auto"
              :value="model.mainImage"
              @input="
                file => {
                  model.mainImage = file;
                }
              "
            />
            <p class="text-center">
              La imagen debe contener un tamaño de 815x257 píxeles
            </p>
          </validation-provider>
        </custom-callout>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Documento:</div>
              <div class="color-black font-16">
                {{ mainImageFile.documentTypeName | empty }}
              </div>
            </div>
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Archivo:</div>
              <div class="color-black font-16">
                {{ mainImageFile.fileName | empty }}
              </div>
            </div>
            <div
              class="col mt-3 mt-md-0 d-flex justify-content-end align-items-center"
            >
              <action-button
                id="download-main-btn"
                class="btn-action-size ml-2"
                i="fas fa-file-download"
                variant="success"
                @click="onDownloadFile(mainImageFile.documentId)"
              />
              <action-button
                id="replace-main-btn"
                class="px-1 btn-action-size ml-2"
                i="fas fa-undo-alt"
                variant="outline-success"
                @click="onReplaceMainFileHandler()"
              />
              <input
                id="mainFile"
                ref="mainRef"
                type="file"
                style="display: none"
                accept="image/*"
                @change="onUploadMainFileHandler()"
              />
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import IconView from "icon-view";
import CustomCallout from "custom-callout";
import CustomFileInput from "CustomFileInput";
import ActionButton from "ActionButton";

import _generalService from "@/services/pei/general";
import documentsService from '@/services/documents';

export default {
  name: "DocumentsSection",
  components: {
    IconView,
    CustomCallout,
    CustomFileInput,
    ActionButton
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    mainImageFile: {
      type: Object,
      default: () => {}
    },
    thumbnailImageFile: {
      type: Object,
      default: () => {}
    },
    data() {
      return {
        model: { ...this.value }
      };
    },
  },
  data() {
    return {
      mainImage: null,
      thumbnail: null
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    hasMainImageFile() {
      return (this.mainImageFile?.documentId);
    },
    hasThumbnailImageFile() {
      return (this.thumbnailImageFile?.documentId);
    },
  },
  methods: {
    downloadFile(id) {
      if (id) {
        _generalService.downloadDocumentByAttachmentId(id);
      }
    },
    onDownloadFile(documentId) {
      documentsService.dowloadPublicPortalFileShare(documentId);
    },
    async onReplaceThumbnailFileHandler() {
      this.$refs.thumbnailRef.click();
    },
    async onUploadThumbnailFileHandler() {
      let files = this.$refs.thumbnailRef.files;
      if (files.length > 0) {
        this.model.thumbnail = files[0];
        this.thumbnailImageFile.fileName = files[0].name;
      }
    },
    async onReplaceMainFileHandler() {
      this.$refs.mainRef.click();
    },
    async onUploadMainFileHandler() {
      let files = this.$refs.mainRef.files;
      if (files.length > 0) {
        this.model.mainImage = files[0];
        this.mainImageFile.fileName = files[0].name;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .justify-content-start {
  justify-content: center !important;
  margin-bottom: 1rem;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}

::v-deep .btn-action-size > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}
</style>
